export default "__VITE_ASSET__83d5794f__"